import React from "react";
export const WhatsAppFAB = () => {
  const handleClick = () => {
    window.open("https://wa.me/9221111524246?text=Hi", "_blank");
  };
  return (
    <a type="button" className="btn btn-success fab" onClick={handleClick}>
      {/* <FaWhatsapp size={24} /> */}
      <i className="fa-brands fa-whatsapp"></i>
    </a>
  );
};
